import { LinkShape } from '../services/types';
import { SWAP_ITEM_ID } from './constants';

const filterSwapElement = (links: LinkShape[]) => links.filter((link) => link.id !== SWAP_ITEM_ID);

export { filterSwapElement };
